import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { PROFILE } from '../../../../constants/strings';
import Icon from '../../../Icon';
import styles from './index.styl';

export const AppleHealth = () => {
  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <FormattedMessage {...PROFILE.deviceSetup.appleHealth} />
      </div>
      <div className={styles.content}>
        <div className={styles.iconInfo}>
          <Icon name="icon-info" size={16} />
        </div>
        <div className={styles.description}>
          <FormattedMessage {...PROFILE.deviceSetup.appleHealthDescription} />
        </div>
      </div>
    </div>
  );
};

AppleHealth.propTypes = {
  formatMessage: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/DeviceSetup/AppleHealth/index.jsx